import axios from 'axios';
import { configs } from '../app/app-configs';
import { PaginatedResponse } from './model/paginated-response';
import {
    BiometricTransaction,
    BiometricTransactionSearchCriteria,
} from './model/biometric.model';

export const getBiometricDeviceTransactionPage = async (
    search: BiometricTransactionSearchCriteria,
): Promise<PaginatedResponse<BiometricTransaction>> => {
    return await axios
        .get(
            `${configs.BASE_URL}/biometric-transactions/devices/${search.deviceId}?page=${search.pagination.page}&size=${search.pagination.size}`,
        )
        .then((res) => {
            return res.data as PaginatedResponse<BiometricTransaction>;
        });
};